import React, {useContext} from 'react';
import Header from "../components/Header";
import SimpleHeader from "../components/SimpleHeader";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { LanguageContext } from "../languages/LanguageContext";
import PageTitle from "../components/PageTitle";

const Imprint = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <>
            <PageTitle title='Imprint' />
            <Header />
            <div className='main-container'>
                <SimpleHeader
                    title={"imprint"}
                    route={"imprint"}
                    url={"imprint"}
                />
                <div className='imprint-container flex col gap-1 max-w'>
                    <div className='company-name flex col'>
                        © BVÖ Bildungsberatung & Vermittlungsagentur GmbH
                    </div>
                    <div className='address flex col'>
                        <span>Ankershofenstraße 8, Stiege 2 <br/> 9020 Klagenfurt am Wörthersee <br/> Österreich <br/></span>
                    </div>
                    <div className='contact'>
                        <span><b>Tel</b> +43 699 120 35834</span><br/>
                        <span><b>Tel</b>  +370 699 35834</span>
                    </div>
                    <div className='media'>
                        <span><b>Email</b> <Link to='mailto:aldona.biedermann@gmail.com'>aldona.biedermann@gmail.com</Link></span><br />
                        <span><b>Website</b> <Link to='https://abiedermann.at/'>www.abiedermann.at</Link></span>
                    </div>
                    <div className='id'>
                        <span><b>UID</b> ATU 69652707</span><br/>
                    </div>
                    <div className='policy'>
                        <span>Please also pay attention to our privacy policy, which you can find <Link to='/policy'>here</Link>.</span>
                    </div>
                    <div className='credits flex gap-2 wrap'>
                        <div className='programming'>
                            <h3>{translations[language]["programmingAndDesign"]}</h3>
                            <div className='item flex ai-c gap-sm'>
                                <HiOutlineArrowNarrowRight className='icon' />
                                <Link to='mailto:krisklavs@gmail.com'>krisklavs@gmail.com</Link>
                            </div>
                        </div>
                        <div className='video'>
                            <h3>Video</h3>
                            <div className='item flex ai-c gap-sm'>
                                <HiOutlineArrowNarrowRight className='icon' />
                                <Link to='https://www.youtube.com/@Travel-memories'>Travel Memories</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Imprint;